// import PageContextData from './pd-page-context-data.json'
// import ServiceData from './pd-service-data.json'

const getPageContextData = () => {
    if(window.pageContextData) {
        return window.pageContextData
    } else {
        console.log("No Page Context Data found on page. Reverting to LOCAL JSON data.")
        return []//PageContextData
    }
}

const getServiceData = () => {
    if(window.serviceData) {
        return window.serviceData
    } else {
        console.log("No Service Data found on page. Reverting to LOCAL JSON data.")
        return {}//ServiceData
    }
}

export const AppData = {
    servicedata: getServiceData(),
    pagecontextdata: getPageContextData()
}
